import _Number$MAX_SAFE_INTEGER from "@babel/runtime-corejs3/core-js/number/max-safe-integer";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _lastIndexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/last-index-of";
import { formatMoneyValueLong } from "./money";
import { toSentence } from "./text";
import { LABELS_CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import { formatNumeral } from "./helpers";
import i18n from "@Shared/@i18n";
import { isObject } from "lodash";
export const collapseCardName = card => {
  const random = Math.floor(Math.random() * _Number$MAX_SAFE_INTEGER) + 1;
  return `card-${card}-${random}-collap`;
};
export const inputName = (sectionKey, multi, inputKey, group, multiGroup, auto = true, type = "", count = 0, subGroup) => {
  if (isObject(inputKey)) {
    const {
      key,
      group: hGroup,
      multiGroup: hMultiGroup,
      count: hCount
    } = inputKey.hash;
    inputKey = key;
    group = hGroup;
    multiGroup = hMultiGroup;
    auto = false;
    count = hCount;
  }
  if (isObject(type)) {
    type = type.hash.type;
  }
  if (isObject(count)) {
    count = count.hash.count;
  }
  if (isObject(subGroup)) {
    subGroup = subGroup.hash.subGroup;
  }
  const types = {
    text: ":string",
    email: ":string",
    number: ":string",
    slider: ":string"
  };
  const serializerType = types[type] || ":auto";
  if (group) group = `[${group}]`;
  if (subGroup) subGroup = `[${subGroup}]`;
  const groupKey = `${group || ""}${subGroup || ""}${group && multiGroup && "[]" || ""}[${inputKey}]`;
  count = `[${count > 0 ? count : 0}]`;
  return `${sectionKey}${multi && count || ""}${groupKey}${auto && `${serializerType}` || ""}`;
};
export const addressName = multi => multi ? "addresses[]" : "address";
export const parseInputSize = (size = {
  sm: 12
}) => {
  let gridClass = "";
  _Object$keys(size).forEach(key => {
    gridClass += size[key] === "0" ? "col" : `col-${key}-${size[key]} `;
  });
  return gridClass;
};
export const parseValidationClass = validations => {
  if (!validations) return "";
  const validationParser = {
    required: "required",
    "num-child": "fe-num-child",
    number: "fe-num-field",
    "text-update": "fe-text-update",
    "section-toggler": "fe-section-toggler",
    rate: "fe-rate",
    "phone-number-ext": "fe-phone-ext"
  };
  const arrayClass = _mapInstanceProperty(validations).call(validations, val => validationParser[val] || val || "");
  return arrayClass.join(" ");
};
export const parseContainerClass = validations => {
  if (!validations) return "";
  const validationParser = {
    dollar: "dollar-prepend",
    percentage: "perc-prepend",
    hidden: "d-none"
  };
  const arrayClass = _mapInstanceProperty(validations).call(validations, val => `${validationParser[val]}` || val || "");
  return arrayClass.join(" ");
};
export const calcSquareCols = options => {
  if (options.length % 3 == 0) return "4";
  return "3";
};
export const inputRequired = validations => validations && _includesInstanceProperty(validations).call(validations, "required");
export const validateDollar = validations => validations && _includesInstanceProperty(validations).call(validations, "dollar");
export const validatePercentage = validations => validations && _includesInstanceProperty(validations).call(validations, "percentage");
export const validateLabel = validations => validations && _includesInstanceProperty(validations).call(validations, "changing-label");
export const validateNumber = validations => validations && _includesInstanceProperty(validations).call(validations, "number");
export const newApplicationFlowCard = ({
  columns,
  card
}, {
  sections,
  sameCard
}) => {
  var _context;
  if (!card) return true;
  if (sameCard) return false;
  const [pivotColumn] = columns;
  const currentCardPivotColumns = _mapInstanceProperty(_context = _filterInstanceProperty(sections).call(sections, sections => sections.card === card)).call(_context, ({
    columns
  }) => columns[0]);
  const index = _findIndexInstanceProperty(currentCardPivotColumns).call(currentCardPivotColumns, ({
    key
  }) => key === pivotColumn.key);
  return index === 0;
};
export const newApplicationFlowCollapse = ({
  group,
  columns
}, {
  sections
}) => {
  var _context2;
  const [pivotColumn] = columns;
  const currentCardPivotColumns = _mapInstanceProperty(_context2 = _filterInstanceProperty(sections).call(sections, sections => sections.group === group)).call(_context2, ({
    columns
  }) => columns[0]);
  const index = _findIndexInstanceProperty(currentCardPivotColumns).call(currentCardPivotColumns, ({
    key
  }) => key === pivotColumn.key);
  return index === 0;
};
export const lastApplicationFlowCollapse = ({
  group,
  columns
}, {
  sections
}) => {
  var _context3;
  const [pivotColumn] = columns;
  const currentCardPivotColumns = _mapInstanceProperty(_context3 = _filterInstanceProperty(sections).call(sections, sections => sections.group === group)).call(_context3, ({
    columns
  }) => columns[0]);
  const index = _findIndexInstanceProperty(currentCardPivotColumns).call(currentCardPivotColumns, ({
    key
  }) => key === pivotColumn.key);
  return index === currentCardPivotColumns.length - 1;
};
export const isFirstGroup = ({
  sections
}, group) => {
  const groups = _mapInstanceProperty(sections).call(sections, ({
    group
  }) => group);
  const index = _findIndexInstanceProperty(groups).call(groups, item => item === group);
  return index === 0;
};
export const firstColumnKey = columns => columns[0].key;
export const getRadioInputType = options => {
  if (options.length !== 2) return "auto";
  return options.every(({
    value
  }) => typeof value === "boolean") ? "boolean" : "auto";
};
export const cleanUpSections = data => {
  const cleanValuesToSections = sections => {
    sections.forEach(({
      columns
    }) => {
      columns.forEach(column => {
        column.value = null;
      });
    });
    return sections;
  };
  data = cleanValuesToSections(data);
  return _JSON$stringify(data);
};
export const getGroupIncrementalKey = (key, parentIndex, isFirst) => {
  return isFirst ? key : `${key}-${parentIndex}`;
};
export const getGroupKey = (group, index) => {
  return `${group}-${index}`;
};
export const groupWithInfo = (group, sectionGroups) => {
  if (!group || !sectionGroups) return false;
  return !!sectionGroups[group];
};
export const addressesTitle = (first, idx) => {
  if (first) return "Current Address";
  return `Previous Address - ${idx}`;
};
export const getGroupSectionsData = (group, sectionGroups, sections, columns) => {
  var _context4;
  if (!group || !sectionGroups) return false;
  const [pivotColumn] = columns;
  const currentCardPivotColumns = _mapInstanceProperty(_context4 = _filterInstanceProperty(sections).call(sections, sections => sections.group === group)).call(_context4, ({
    columns
  }) => columns[0]);
  const index = _findIndexInstanceProperty(currentCardPivotColumns).call(currentCardPivotColumns, ({
    key
  }) => key === pivotColumn.key);
  return index === 0 && sectionGroups[group] ? sectionGroups[group] : false;
};
export const getGroupSections = (group, sections) => _JSON$stringify(_filterInstanceProperty(sections).call(sections, section => section.group === group));
export const collapseKey = (key, index) => {
  if (index === 0) return key;
  return `${key}-${index}`;
};
export const parseValue = value => {
  const parsing = {
    new: "Application Incomplete",
    pending: "Pending Application",
    submitted: "Application Submitted",
    "in-review": "Under Review",
    completed: "Application Completed",
    cancelled: "Application Cancelled",
    scheduled: "Scheduled",
    "first-contact": "First Contact",
    referred: "Referred",
    initiated: "Initiated"
  };
  return parsing[value] || value;
};
export const multiOptionInner = values => {
  const checkedOnes = _filterInstanceProperty(values).call(values, elem => {
    return elem.checked === true;
  }).length;
  return checkedOnes > 0 ? `${checkedOnes} selected` : "Select";
};
export const getMultioptionChecked = values => {
  return _filterInstanceProperty(values).call(values, elem => {
    return elem.checked === true;
  }).length;
};
export const getFlowTitle = (flow, {
  sections
}) => {
  if (!flow) return "Pending";
  let title;
  sections.forEach(({
    columns
  }) => columns.forEach(({
    options
  }) => {
    title = _findInstanceProperty(options).call(options, option => option.value === flow).title;
  }));
  return title;
};
export const getSectionCollapseName = (section, index) => {
  return `${section} ${index + 1}`;
};
export const getGroupDataLenght = (data, group) => {
  return data[group] && !!data[group].length;
};
export const sectionCuantitative = placeholder => {
  const timeRelatedWords = ["years", "year", "months", "month", "days", "(sq. ft)"];
  return timeRelatedWords.some(word => _includesInstanceProperty(placeholder).call(placeholder, word));
};
export const extractCuantitative = placeholder => {
  return placeholder.substr(_lastIndexOfInstanceProperty(placeholder).call(placeholder, "(") + 1, _lastIndexOfInstanceProperty(placeholder).call(placeholder, ")")).replace(")", "").replace("in", "");
};
export const displayTextSection = column => {
  const {
    placeholder,
    value,
    validation,
    title = ""
  } = column;
  if (validateDollar(validation)) return formatMoneyValueLong(value);
  if (validatePercentage(validation)) return `${value} %`;
  if (sectionCuantitative(placeholder)) return `${value} ${extractCuantitative(placeholder)}`;
  if (sectionCuantitative(title)) return `${value} ${extractCuantitative(title)}`;
  return toSentence(value);
};
export const summarySectionNotEmpty = summarySection => {
  const {
    sections
  } = summarySection;
  let atLeastOneValue = false;
  sections.forEach(section => {
    const {
      columns
    } = section;
    columns.forEach(column => {
      if (column.value) atLeastOneValue = true;
    });
  });
  return atLeastOneValue;
};
export const getTogglerAction = (value, summarySection) => {
  const {
    options
  } = summarySection;
  const {
    action
  } = _findInstanceProperty(options).call(options, option => option.value === value);
  return action;
};
export const validatesValue = column => {
  return "undefined" !== typeof column["value"];
};
export const extractLabel = column => {
  const {
    value,
    options
  } = column;
  if (!options || !options.length) return value;
  return _findInstanceProperty(options).call(options, option => option.value === value)["label"];
};
export const getApplicationFlow = flow => {
  const parser = {
    "refinance-approval": "Refinance",
    "purchase-preapproval": "Pre-approval",
    "purchase-approval": "Purchase",
    "switch-transfer": "Switch / Transfer"
  };
  return parser[flow];
};
export const getApplicationStatusLabel = applicationStatus => {
  return LABELS_CLIENT_APPLICATION_STATUS[applicationStatus];
};

/**
 * Return an ordinal representation of the applicantIndex if first name and last name are missing
 *  (i.e. Main Applicant, 1st Applicant, 2nd Application, ...)
 *
 * @param {Number} applicantIndex index of the applicant, main applicant is always 0
 * @param {*} applicantDetails applicant object as it is in the ApplicationStore
 */
export const getApplicantName = (applicantIndex, applicantDetails) => {
  const firstName = (applicantDetails == null ? void 0 : applicantDetails["first-name"]) || "";
  const lastName = (applicantDetails == null ? void 0 : applicantDetails["last-name"]) || "";
  if (!firstName && !lastName) {
    if (applicantIndex === 0) return i18n.t("application-form.main-applicant");
    return `${formatNumeral(applicantIndex, "0o")} ${i18n.t("application-form.co-applicant").toLowerCase()}`;
  }
  return [firstName, lastName].join(" ");
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("collapseCardName", collapseCardName);
  _Handlebars.registerHelper("inputName", inputName);
  _Handlebars.registerHelper("addressName", addressName);
  _Handlebars.registerHelper("parseInputSize", parseInputSize);
  _Handlebars.registerHelper("parseValidationClass", parseValidationClass);
  _Handlebars.registerHelper("parseContainerClass", parseContainerClass);
  _Handlebars.registerHelper("calcSquareCols", calcSquareCols);
  _Handlebars.registerHelper("inputRequired", inputRequired);
  _Handlebars.registerHelper("validateDollar", validateDollar);
  _Handlebars.registerHelper("validatePercentage", validatePercentage);
  _Handlebars.registerHelper("validateLabel", validateLabel);
  _Handlebars.registerHelper("validateNumber", validateNumber);
  _Handlebars.registerHelper("newApplicationFlowCard", newApplicationFlowCard);
  _Handlebars.registerHelper("isFirstGroup", isFirstGroup);
  _Handlebars.registerHelper("firstColumnKey", firstColumnKey);
  _Handlebars.registerHelper("getRadioInputType", getRadioInputType);
  _Handlebars.registerHelper("cleanUpSections", cleanUpSections);
  _Handlebars.registerHelper("getGroupIncrementalKey", getGroupIncrementalKey);
  _Handlebars.registerHelper("getGroupKey", getGroupKey);
  _Handlebars.registerHelper("groupWithInfo", groupWithInfo);
  _Handlebars.registerHelper("addressesTitle", addressesTitle);
  _Handlebars.registerHelper("getGroupSectionsData", getGroupSectionsData);
  _Handlebars.registerHelper("getGroupSections", getGroupSections);
  _Handlebars.registerHelper("collapseKey", collapseKey);
  _Handlebars.registerHelper("parseValue", parseValue);
  _Handlebars.registerHelper("multiOptionInner", multiOptionInner);
  _Handlebars.registerHelper("getMultioptionChecked", getMultioptionChecked);
  _Handlebars.registerHelper("getFlowTitle", getFlowTitle);
  _Handlebars.registerHelper("getSectionCollapseName", getSectionCollapseName);
  _Handlebars.registerHelper("getGroupDataLenght", getGroupDataLenght);
  _Handlebars.registerHelper("sectionCuantitative", sectionCuantitative);
  _Handlebars.registerHelper("extractCuantitative", extractCuantitative);
  _Handlebars.registerHelper("displayTextSection", displayTextSection);
  _Handlebars.registerHelper("summarySectionNotEmpty", summarySectionNotEmpty);
  _Handlebars.registerHelper("getTogglerAction", getTogglerAction);
  _Handlebars.registerHelper("validatesValue", validatesValue);
  _Handlebars.registerHelper("extractLabel", extractLabel);
  _Handlebars.registerHelper("getApplicationFlow", getApplicationFlow);
};